import React, { Component } from "react";
import { connect } from "react-redux";
import { explodeString } from "../../utilities";
import "./style.css";

class A0 extends Component {
  render() {
    const where = explodeString(this.props.poster.field_where);
    let ariaLabel = '';
    switch (`${this.props.poster.field_type}-${this.props.poster.field_color}`) {
      case 'ouders-stedelijk':
        ariaLabel += 'Man en kind met fietshelm in de stad. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'ouders-landelijk':
        ariaLabel += 'Man en kind met fietshelm in de natuur. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'ouders-dorp':
        ariaLabel += 'Man en kind met fietshelm in een dorpsstraat. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'ouders_2-stedelijk':
        ariaLabel += 'Man en kind met fietshelm in de stad. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'ouders_2-landelijk':
        ariaLabel += 'Man en kind met fietshelm in de natuur. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'ouders_2-dorp':
        ariaLabel += 'Man en kind met fietshelm in een dorpsstraat. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'forenzen-stedelijk':
        ariaLabel += 'Vrouw met fietshelm in de stad. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'forenzen-landelijk':
        ariaLabel += 'Man met fietshelm in de natuur. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'forenzen_2-stedelijk':
        ariaLabel += 'Vrouw met fietshelm in de stad. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'forenzen_2-dorp':
        ariaLabel += 'Vrouw met fietshelm in een dorpsstraat. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'forenzen_2-landelijk':
        ariaLabel += 'Vrouw met fietshelm in de natuur. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'senioren-stedelijk':
        ariaLabel += 'Dame met fietshelm in de stad. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'senioren-landelijk':
        ariaLabel += 'Dame met fietshelm in de natuur. Onderaan staat het logo van Kom veilig thuis.';
        break;
      case 'senioren-dorp':
        ariaLabel += 'Dame met fietshelm in een dorpsstraat. Onderaan staat het logo van Kom veilig thuis.';
        break;
      default :
        break;
    }
    return (
      <section
        id="a0"
        className={`a0 poster-${this.props.poster.field_type}`}
        style={{
          "--fontRatio": this.props.poster.fontRatio,
        }}
      >
        <img
          src={require(`../../images/${this.props.poster.field_type}/${this.props.poster.field_color}.jpg`)}
          alt={`Poster Zet 'm op: ${ariaLabel}`}
          className="poster-image"
        />

        <div className="a0-wrapper" data-color={this.props.poster.field_color}>
          <div ref="heading" className="heading a0-heading" id="heading">
            <span
              className="calc"
              dangerouslySetInnerHTML={{ __html: where }}
            ></span>
          </div>
        </div>
      </section>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    poster: state.poster,
  };
};

export default connect(mapStateToProps)(A0);
